// src/components/common/FormViewPaperContent.jsx
import React from "react";
import FileList from "../papers/FileList";
import ApprovalLine_print from "../../approval/ApprovalLine_print";
import TableCell from "../ui/TableCell";

export default function FormViewPaperContent({
  module,
  app_top,
  approvalLines,
  doc_name,
  doc_eng,
  data,
  meta,
  dns,
  project,
  projectName,
  children,
  print = false,
  me,
}) {
  return (
    <>
      {/* ===== 헤더 ===== */}
      <header
        className="doc-header pb-5 border-b mb-6 text-center"
        style={{ pageBreakInside: "avoid" }}
      >
        {(module === "approval" || app_top) && (
          <div className="flex justify-end mb-3">
            <ApprovalLine_print lines={approvalLines} />
          </div>
        )}

        <div className="text-title">
          {doc_name || data.header?.title || data.title || "-"}
        </div>

        {doc_eng && <div className="text-xs mt-1">({doc_eng})</div>}

        <div className="overflow-hidden mt-6">
          <table className="w-full table-fixed text-left">
            <tbody>
              <tr>
                <TableCell
                  label="문서 번호"
                  colSpan={3}
                  value={data.doc_dns || dns || "-"}
                />
              </tr>
              <tr>
                <TableCell
                  label="현장명"
                  colSpan={3}
                  value={data.project_name || projectName || project || "-"}
                />
              </tr>
              <tr>
                <TableCell
                  label="작성자"
                  value={data.created_by?.name || "-"}
                />
                <TableCell
                  label="작성일"
                  value={
                    data.created_at
                      ? new Date(data.created_at).toLocaleDateString()
                      : "-"
                  }
                />
              </tr>
              <tr>
                <TableCell
                  label="문서 제목"
                  colSpan={3}
                  value={data.header?.title || data.title || "-"}
                />
              </tr>
            </tbody>
          </table>
        </div>
      </header>

      {/* ===== 🔥 핵심: 문서 본문 ===== */}
      {typeof children === "function"
        ? children({ meta, data, project, approvalLines, me })
        : React.Children.map(children, (child) =>
            React.isValidElement(child)
              ? React.cloneElement(child, {
                  meta,
                  data,
                  project,
                  approvalLines,
                  me,
                })
              : child
          )}

      {/* ===== 첨부 (화면 전용) ===== */}
      {!print && (
        <>
          <h2 className="text-body-bold mb-1 mt-4">첨부자료</h2>
          <div className="border rounded-xl p-3">
            <FileList dns={dns} />
          </div>
        </>
      )}
    </>
  );
}
